<template>
  <path pid="0" d="M13.71 4.29l-.11-.09h-.25L13.2 4H12.48l-.08.07-6 6a1 1 0 000 1.42l.1.08a1 1 0 001.32-.08L12 7.41V21a1 1 0 001 1h.12a1 1 0 00.88-1V7.41l4.29 4.3a1 1 0 001.42-1.42zM16.59 4.76l.09.08-.08-.08h-.01zM15.89 4.55z"/>
</template>
